import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ApproachDTO {
    type: string;
    start: {
        ident?: string;
        lat: number;
        lon: number;
        alt: number;
        magnetic_variation_west: number;
    };
    end: {
        ident?: string;
        lat: number;
        lon: number;
        alt: number;
        magnetic_variation_west: number;
    };
}

interface DebugState {
    isEnabled: boolean;
    features: { [settingName: string]: boolean };
    approach?: ApproachDTO[];
}

const initialState: DebugState = {
    isEnabled: false,
    features: {
        debriefPreciseTime: false,
        debriefApproachDebug: false,
    },
    approach: undefined,
};

const debugSlice = createSlice({
    name: 'debug',
    initialState,
    reducers: {
        toggleDebugMode: state => {
            state.isEnabled = !state.isEnabled;
        },
        enableFeature: (state, action: PayloadAction<string>) => {
            state.features = { ...state.features, [action.payload]: true };
        },
        disableFeature: (state, action: PayloadAction<string>) => {
            state.features = { ...state.features, [action.payload]: false };
        },
        setDebugMode: (state, action: PayloadAction<boolean>) => {
            state.isEnabled = action.payload;
        },
        resetDebugSettings: () => {
            return initialState;
        },
        setApproach: (
            state,
            action: PayloadAction<ApproachDTO[] | undefined>
        ) => {
            state.approach = action.payload;
        },
    },
});

export const {
    toggleDebugMode,
    setDebugMode,
    enableFeature,
    disableFeature,
    resetDebugSettings,
    setApproach,
} = debugSlice.actions;

export default debugSlice;
